import { jsx as r } from "react/jsx-runtime";
import { createContext as o, useContext as n, useEffect as t, useState as e } from "react";
const i = { loading: true, setLoading: () => {
} }, a = o(i), d = () => n(a), c = (r2) => {
  const o2 = d();
  return t(() => {
    o2.setLoading(r2);
  }, [o2, r2]), o2;
}, s = ({ children: o2 }) => {
  const [n2, t2] = e(i.loading);
  return r(a.Provider, { value: { loading: n2, setLoading: (r2) => t2(r2) }, children: o2 });
};
export {
  a as PageContext,
  s as PageProvider,
  d as usePageContext,
  c as useWatchPageLoading
};
//# sourceMappingURL=PageProvider.js.map
